import styled from "styled-components";
import { breakpoints, maxBreakpoints } from "../../../../../shared-logic/themes/toyotaTheme";
import { theme } from "../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Slider = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    margin-inline: calc(var(--spacing-2) * -1);
    overflow: hidden;

    @media screen and (min-width: ${breakpoints.md}) {
        margin-inline: calc(var(--spacing-3) * -1);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        margin-inline: auto;
        margin-bottom: calc(var(--spacing-3) / 2);
    }

    @supports not (margin-inline: 0) {
        margin-left: calc(var(--spacing-2) * -1);
        margin-right: calc(var(--spacing-2) * -1);

        @media screen and (min-width: ${breakpoints.md}) {
            margin-left: calc(var(--spacing-3) * -1);
            margin-right: calc(var(--spacing-3) * -1);
        }

        @media screen and (min-width: ${breakpoints.xl}) {
            margin-left: auto;
            margin-right: auto;
        }
    }
`;

export const SliderViewport = styled.div<{
    scrollable: boolean;
}>`
    display: flex;
    width: 100%;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    overscroll-behavior-inline: contain;
    -ms-overflow-style: none;
    scrollbar-width: none;
    pointer-events: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @media screen and (max-width: ${breakpoints.xxl}) {
        gap: 10px;
        pointer-events: all;
        overflow-x: ${({ scrollable }) => (scrollable ? "auto" : "hidden")};
    }
`;

// styles based on old Tridion carousel from GFI
export const ThreeSixtyIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    font-weight: bold;
    color: ${theme.colors.primaryWhite};
    background: ${theme.colors.primaryBlack};
    border-radius: 50%;
    transition: opacity 0.3s;
    opacity: 0.8;
`;

export const CenteredOverlay = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    z-index: 1;

    &:hover ${ThreeSixtyIcon} {
        opacity: 1;
    }
`;

export const PlaceholderWrapper = styled(CenteredOverlay)`
    width: 100%;
    height: 100%;
    background: ${theme.colors.grey1};
    border: 1px solid ${theme.colors.grey3};
    border-radius: 8px;
    transition: opacity 0.3s;
`;

export const FullScreenButton = styled.div`
    @media screen and (max-width: ${maxBreakpoints.md}) {
        display: none;
    }
`;

export const CarouselButtons = styled.div`
    display: flex;
    position: absolute;
    bottom: var(--spacing-3);
    right: var(--spacing-3);
    column-gap: var(--spacing-3);
    z-index: 1000;
    @media screen and (max-width: ${maxBreakpoints.lg}) {
        right: var(--spacing-5);
    }
`;

export const SliderButtons = styled.div`
    display: flex;
    bottom: 0px;
    right: 0px;
    width: fit-content;
    gap: 5px;

    &[hidden] {
        display: none;
    }

    @media screen and (max-width: ${maxBreakpoints.md}) {
        display: none;
    }
`;

export const Actions = styled.div`
    display: flex;
    position: absolute;
    bottom: 0;
    justify-content: space-between;
    width: 100%;
    padding: var(--spacing-3);
    @media screen and (max-width: ${maxBreakpoints.lg}) {
        padding: var(--spacing-3) var(--spacing-5);
    }
    @media screen and (max-width: ${maxBreakpoints.md}) {
        bottom: 35px;
        padding: var(--spacing-3) var(--spacing-5);
    }
    @media screen and (max-width: ${maxBreakpoints.sm}) {
        padding: var(--spacing-3) var(--spacing-4);
    }
`;

export const Content = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

export const Reserved = styled.span`
    padding: var(--spacing-1) var(--spacing-2);
    background: var(--color-primary-white);
    border-radius: 20px;
    opacity: 95%;
`;

export const Badges = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
`;
